import { useDispatch } from 'react-redux';
import { GET_DOWNLOAD_DOCUMENT } from 'store/key';
import { SHyperLink } from 'style/CommonStyledComponent';
import { getTimeWithTimeZone } from 'utility/general';
import { ACKNOWLEDGED, APPROVED, DISAPPROVED } from 'utility/lookup';
import API from 'api/call';

const useApprovalHistoryData = ({ approvalHistory = [] }) => {
    const dispatch = useDispatch();

    const getStatusDisplay = (statusId) => {
        if (statusId === APPROVED) {
            return 'Approved';
        } else if (statusId === DISAPPROVED) {
            return 'Disapproved';
        } else if (statusId === ACKNOWLEDGED) {
            return 'Acknowledged';
        } else {
            return '-';
        }
    };

    const rawColumn = [
        // {
        //     field: 'createDtm',
        //     headerName: 'Date',
        //     width: 180,
        //     valueGetter: (params) => {
        //         return getTimeWithTimeZone(params.value).format('YYYY-MM-DD HH:mm:ss');
        //     },
        // },
        { field: 'documentType', headerName: 'Document type', width: 150 },
        // {
        //     field: 'status',
        //     headerName: 'Application Status',
        //     width: 130,
        //     valueGetter: (params) => {
        //         return params.value ?? '-';
        //     },
        // },
        // {
        //     field: 'reviewDueDate',
        //     headerName: 'Review Due Date',
        //     width: 130,
        //     valueGetter: (params) => {
        //         return params.value ?? '-';
        //     },
        // },
        {
            field: 'reviewType',
            headerName: 'Review type',
            width: 130,
            valueGetter: (params) => {
                return params.value ?? '-';
            },
        },
        {
            field: 'decision',
            headerName: 'Decision',
            width: 130,
            valueGetter: (params) => {
                return getStatusDisplay(params.value);
            },
        },
        {
            field: 'decisionDate',
            headerName: 'Decision Date',
            width: 130,
            valueGetter: (params) => {
                if (!params.value) {
                    return '-';
                }

                return getTimeWithTimeZone(params.row.decisionDate).format('YYYY-MM-DD');
            },
        },
        {
            field: 'reason',
            headerName: 'Decision Reason',
            width: 250,
        },
        {
            field: 'approvalLetterFileName',
            headerName: 'Approval Letter',
            width: 220,
            valueGetter: (params) => {
                return (
                    params.value ? <SHyperLink
                        onClick={() => {
                            dispatch({
                                type: GET_DOWNLOAD_DOCUMENT,
                                payload: {
                                    data: {
                                        docType: params.row.docType,
                                        docId: params.row.docId,
                                    },
                                    apiUrl: API.consolidation.downloadApprovalLetter,

                                },
                            });
                        }}
                    >
                        {params.value}
                    </SHyperLink> : '-'
                );
            },
        },
        {
            field: 'approvalLetterDtm',
            headerName: 'Upload date of approval letter',
            width: 200,
            valueGetter: (params) => {
                return params.value ? getTimeWithTimeZone(params.value).format('YYYY-MM-DD HH:mm') : '-';
            },
        },
    ];

    return { columns: rawColumn, rawColumn: rawColumn, rows: approvalHistory ?? [] };
};

export default useApprovalHistoryData;
